import { Doms } from "../../../components/doms.js";

const fields = ['name', 'email', 'password', 'phone', 'organization', 'occupation', 'idCity', 'idState', 'permalink'];
const formName = 'account';
const doms = new Doms();

export function GetFormData() {
  let data = {};
  for (let i = 0; i < fields.length; i++) {
    data[fields[i]] = doms.getValue(formName + '-' + fields[i]);
  }

  data.image = doms.getIdcod(formName + '-image');
  data.idCountry = '5';

  return data;
}

export function ClearFormErrors() {
  fields.map(f => doms.setHTML(formName + '-' + f + '-error', ''));
  doms.setHTML(formName + '-status', '');
}


export function ClearFields() {
  fields.map(f => doms.setValue(formName + '-' + f + '', ''));
  ClearFormErrors();
}


export function ShowErrors(_errors) {
  ClearFormErrors();
  for (let i = 0; i < _errors.length; i++) {
    doms.setHTML(formName + '-' + _errors[i].id + '-error', _errors[i].message);
    doms.focus(formName + '-' + _errors[i].id);
  }
  if (_errors.length > 0) {
    doms.setHTML(formName + '-status', '<span style="color: var(--rojo1)">Hay campos sin completar.</span>');
  }
}
